import { PageContainer } from '@/components/page/PageContainer';
import { PageSizer, SizerMode } from '@/components/page/PageSizer';
import { Button } from '@/components/shared/button/Button';
import { TSTitleCard } from '@/components/shared/card/Card';
import { Feature } from '@/services/backstage/Feature';
import { useScheduleRequestStatus } from '@/services/workingPatterns/useScheduleRequestStatus';
import { FunctionComponent } from 'react';
import { FiBell } from 'react-icons/fi';
import { useNavigate, useParams } from 'react-router-dom';
import { TeamMemberGroupedScheduleChangesCard } from './TeamMemberGroupedScheduleChangesDetailsCard';

const TeamMemberRequestsUpcomingScheduleChangesPage: FunctionComponent = () => {
  const { userId } = useParams<'userId'>();
  const navigate = useNavigate();

  const { upcomingApprovedRequests } = useScheduleRequestStatus(userId);

  return (
    <Feature name="requests">
      <PageContainer>
        <PageSizer mode={SizerMode.PAGE} className="justify-items-center">
          <TSTitleCard className="w-full space-y-5 p-5" title="Upcoming Schedule Changes" icon={FiBell}>
            {upcomingApprovedRequests.length === 0 ? (
              <p className="text-gray-400">No upcoming approved schedule changes.</p>
            ) : (
              <TeamMemberGroupedScheduleChangesCard requests={upcomingApprovedRequests} />
            )}
            <div className="flex justify-end">
              <Button big onClick={() => navigate(-1)}>
                Back
              </Button>
            </div>
          </TSTitleCard>
        </PageSizer>
      </PageContainer>
    </Feature>
  );
};

export default TeamMemberRequestsUpcomingScheduleChangesPage;
